export class FilePath {
  constructor(
    public path: string,
    public fullpath: string
  ) {}

  public static hydrate(obj: FilePath): FilePath {
    return new FilePath(obj.path, obj.fullpath);
  }
}
